import { ChannelKitchenPage, ChannelRestaurantPage } from './channel-boards/ChannelBoardPages'
import { KitchenPage } from './kitchen/KitchenPage'
import { NewOrderPage } from './order-builder/NewOrderPage'
import { ListsPage } from './lists/ListsPage'
import { OrdersRedirect } from './lists/OrdersRedirect'
import { PreordersPage } from './preorders/PreordersPage'
import { RestaurantPage } from './restaurant/RestaurantPage'
import { TableMapPage } from './table-map/TableMapPage'

/**
 * `manager-orders` — the POS core.
 *
 * Ported: every page — preorders, lists, kitchen, table-map, new-order,
 * restaurant. What each still owes is in its spec under `docs/pages/`.
 * `orders.tsx` is not ported (owner decision 1); `/orders` redirects to
 * `/lists`, exactly as legacy does.
 */
export const managerOrdersModule = {
  name: 'manager-orders',
  routes: [
    {
      path: '/new-order',
      page: 'new-order',
      guard: { permission: 'new_order' },
      component: NewOrderPage,
    },
    {
      path: '/preorders',
      page: 'preorders',
      guard: { permission: 'preorders' },
      component: PreordersPage,
    },
    {
      // No guard, exactly as legacy mounts it: any signed-in employee may look
      // at the kitchen board. Accepting an order is what needs a permission, and
      // that check lives on the card.
      path: '/kitchen',
      page: 'kitchen',
      component: KitchenPage,
    },
    {
      path: '/restaurant',
      page: 'restaurant',
      guard: { permission: 'restaurant' },
      component: RestaurantPage,
    },
    {
      // §9.688, owner #24 (O79) - a channel's own kitchen, the terrace's *Kuchyňa OFYR*. Open like `/kitchen`
      // (FB-002): any signed-in employee may look at a kitchen board, and accepting is checked on the card.
      path: '/kitchen/channel/:slug',
      page: 'kitchen',
      component: ChannelKitchenPage,
    },
    {
      // §9.688 - and its own *Otvorené stoly*, on `/restaurant`'s own guard.
      path: '/restaurant/channel/:slug',
      page: 'restaurant',
      guard: { permission: 'restaurant' },
      component: ChannelRestaurantPage,
    },
    {
      path: '/table-map',
      page: 'table-map',
      // Legacy gates this on `restaurant`, not on a table-map permission of its
      // own: the floor plan and the order builder are one job.
      guard: { permission: 'restaurant', franchiseModule: 'restaurant.tables' },
      component: TableMapPage,
    },
    {
      path: '/lists',
      page: 'lists',
      guard: { permission: 'lists' },
      component: ListsPage,
    },
    {
      path: '/orders',
      page: 'lists',
      guard: { permission: 'lists' },
      redirectTo: '/lists',
      component: OrdersRedirect,
    },
  ],
} as const

// §9.341 - the component moved to `@agos/ui`; re-exported so this module's own consumers are
// unaffected by where it lives.
export { CancelOrderModal } from '@agos/ui'
export { WaiterHandoverModal } from './handover/WaiterHandoverModal'
// §9.740, owner O111 - the till's *Zaplatiť* for the dispatch board's *Vydaná*, handed over by the shell.
export { CounterPaymentDialog } from './restaurant/CounterPaymentDialog'
export { KitchenPage, ListsPage, NewOrderPage, PreordersPage, RestaurantPage, TableMapPage }
